import React from "react";
import SecondaryHeader from "@ui/Header/Secondary";
import { ReportingHeaderMenu } from "./Menu";
import ReportingProjectFilters from "./Filters/Project";
import ReportingDiagnosisFilters from "./Filters/Diagnosis";
import { styled } from "@linaria/react";
import FilledDataToggle from "./Filters/FilledDataToggle";
import t from "../../../i18n";
import { DownloadLine } from "@ui/IconV2/react";
import Text from "@ui/Text";
import Button from "@ui/Button";
import { exportDiagnosisReporting, exportPerformanceReporting } from "../exportReporting";
import { useTranslations } from "../../../api/useTranslations";
import { useDiagnosisReporting, usePerformanceReporting } from "../../../api/useReporting";
import { useLocation } from "react-router";

const ReportingFilters = styled.div`
  --spacing: 8px;

  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  flex-grow: 1;
  padding: var(--spacing) 0;
  row-gap: var(--spacing);
  justify-content: space-between;

  & > div > :last-child:not(:first-child) {
    margin-top: var(--spacing);
  }
`;

function PerformanceExportButton() {
  const reporting = usePerformanceReporting();
  const handleExportClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      exportPerformanceReporting(reporting);
    },
    [reporting],
  );
  return (
    <Button variant="ghost" leftIcon={<DownloadLine />} slim onClick={handleExportClick}>
      <Text type="body2SemiBold">{t("reporting.export")} </Text>
    </Button>
  );
}

function DiagnosisExportButton() {
  const reporting = useDiagnosisReporting();
  const translations = useTranslations();

  const handleExportClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      exportDiagnosisReporting(reporting, translations);
    },
    [reporting, translations],
  );
  return (
    <Button variant="ghost" leftIcon={<DownloadLine />} slim onClick={handleExportClick}>
      <Text type="body2SemiBold">{t("reporting.export")} </Text>
    </Button>
  );
}

export function ReportingHeader() {
  const location = useLocation();
  return (
    <SecondaryHeader
      title={<ReportingHeaderMenu />}
      nav={
        <>
          <ReportingFilters>
            <div>
              <ReportingProjectFilters />
              {location.pathname === "/reporting/diagnosis" && <ReportingDiagnosisFilters />}
            </div>
            <FilledDataToggle />
            <React.Suspense>
              {location.pathname === "/reporting/diagnosis" ? (
                <DiagnosisExportButton />
              ) : (
                <PerformanceExportButton />
              )}
            </React.Suspense>
          </ReportingFilters>
        </>
      }
    />
  );
}
